import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box, Loader } from '../../../../common/components';
import SchemeChannels from '../DocumentManagement/SchemeChannels/SchemeChannels';
import { actions } from '../../redux/ProductReducer';
import {
  applyFilter,
  refreshData,
} from '../../../../common/components/DataTable/redux/dataTableActions';

const CHANNELS_TABLE_NAME = 'scheme-channels-table';
const InsurerSchemeChannelsList = ({
  actions,
  refreshData,
  applyFilter,
  schemeStatus,
  insurerCode,
}) => {
  const [schemes, setSchemes] = useState([]);
  const [noSchemesFound, setNoSchemesFound] = useState(false);

  useEffect(() => {
    Promise.resolve(actions.getInsurerSchemesByStatus(schemeStatus, insurerCode)).then(
      (schemes) => {
        if (!schemes || !schemes.length) {
          setNoSchemesFound(true);
        } else {
          setSchemes(schemes);
        }
      },
    );
  }, []);

  const removeChannel = (schemeId, channelId) => {
    const values = {
      meta: {
        channels: [channelId],
      },
    };
    Promise.resolve(actions.removeChannelsFromScheme(schemeId, values)).then(() => {
      refreshData(CHANNELS_TABLE_NAME);
    });
  };

  const assignChannel = (schemeId, channelId) => {
    const values = {
      meta: {
        channels: [channelId],
      },
    };
    Promise.resolve(actions.assignChannelsToScheme(schemeId, values)).then(() => {
      refreshData(CHANNELS_TABLE_NAME);
    });
  };

  if (noSchemesFound) {
    return (
      <Box>
        <h2>{`No ${schemeStatus} schemes found`}</h2>
      </Box>
    );
  }

  if (!schemes.length) {
    return <Loader />;
  }

  const filterChannel = (search) => {
    applyFilter(CHANNELS_TABLE_NAME, 'filter[name]', search);
  };

  return (
    <Box>
      {schemes.map((scheme) => (
        <SchemeChannels
          schemeName={scheme.attributes.name}
          removeChannel={removeChannel}
          assignChannel={assignChannel}
          filterChannel={filterChannel}
          schemeId={scheme.id}
          channelsTableName={CHANNELS_TABLE_NAME}
        />
      ))}
    </Box>
  );
};

export default connect(
  (state) => ({
    productManagement: state.productManagement,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    refreshData: bindActionCreators(refreshData, dispatch),
    applyFilter: bindActionCreators(applyFilter, dispatch),
  }),
)(InsurerSchemeChannelsList);
